import { Plus, X } from "lucide-react";

const SLOTS = ["Face", "Profile", "Half body", "Full length"];

function resize(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, 1400 / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(img.src);
      resolve(c.toDataURL("image/jpeg", 0.82));
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

export const PhotoPicker = ({ photos, setPhotos }) => {
  const pick = async (i, file) => {
    if (!file) return;
    const data = await resize(file);
    setPhotos((p) => { const n = [...p]; n[i] = data; return n; });
  };
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="photo-picker">
      {SLOTS.map((label, i) => (
        <div key={label} className="relative">
          <label data-testid={`photo-slot-${i}`} className="group relative flex aspect-[3/4] cursor-pointer flex-col items-center justify-center overflow-hidden border border-dashed border-[#1c1418]/40 transition-colors hover:border-[#1c1418]">
            {photos[i] ? <img src={photos[i]} alt={label} className="h-full w-full object-cover" /> : (
              <>
                <Plus className="h-6 w-6 text-[#e9458f] transition-transform group-hover:rotate-90" />
                <span className="mt-2 font-mono text-[11px] uppercase tracking-[0.15em] text-[#1c1418]/70">{label}</span>
              </>
            )}
            <input type="file" accept="image/*" className="hidden" data-testid={`photo-input-${i}`} onChange={(e) => pick(i, e.target.files?.[0])} />
          </label>
          {photos[i] && (
            <button type="button" data-testid={`photo-remove-${i}`} onClick={() => setPhotos((p) => { const n = [...p]; n[i] = null; return n; })}
              className="absolute right-1 top-1 grid h-7 w-7 place-items-center rounded-full bg-[#1c1418] text-white"><X className="h-4 w-4" /></button>
          )}
        </div>
      ))}
    </div>
  );
};
